module.exports = __webpack_public_path__ + "static/media/medicare-club-logo-white.32e48376.svg";